import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import { ModalProvider } from './hooks/useModal';
import Header from './components/Header/Header';
import HeroSection from './components/HeroSection/HeroSection';
import SupportedBy from './components/SupportedBy/SupportedBy';
import BenefitsSection from './components/BenefitsSection/BenefitsSection';
import HowItWorks from './components/HowItWorks/HowItWorks';
import CTASection from './components/CTASection/CTASection';
import Footer from './components/Footer/Footer';
import Modals from './components/Modals/Modals';

function App() {
  return (
    <ModalProvider>
      <div className="App">
        <Header />
        <HeroSection />
        <SupportedBy />
        <BenefitsSection />
        <HowItWorks />
        <CTASection />
        <Footer />
        <Modals />
      </div>
    </ModalProvider>
  );
}

export default App;
